import { visuallyHiddenStyles } from "@newsela/angelou";
import PropTypes from "prop-types";

import { colorPickerColors } from "./ColorPicker.constants";
import { fieldsetCss } from "./ColorPicker.style";
import ColorPickerRadioButton from "./ColorPickerRadioButton";

const propTypes = {
  selectedColor: PropTypes.string,
  selectedRadioButtonRef: PropTypes.object,
  handleOnChange: PropTypes.func,
};

const ColorPicker = ({
  selectedColor,
  selectedRadioButtonRef,
  handleOnChange,
}) => {
  const currentColor = selectedColor || colorPickerColors[0].penName;

  return (
    <fieldset css={fieldsetCss}>
      <legend css={visuallyHiddenStyles}>
        Choose annotation highlight color
      </legend>
      <div role="radiogroup">
        {colorPickerColors.map((color) => {
          return (
            <ColorPickerRadioButton
              key={color.penName}
              color={color}
              handleOnChange={handleOnChange}
              isSelected={currentColor === color.penName}
              ref={
                currentColor === color.penName ? selectedRadioButtonRef : null
              }
            />
          );
        })}
      </div>
    </fieldset>
  );
};

ColorPicker.propTypes = propTypes;

export default ColorPicker;
